<template>
  <v-snackbar v-model="show" :color="color" top>
    <div class="d-flex align-center">
      {{ message }}
      <v-spacer></v-spacer>
      <v-btn dark text @click.prevent="show = false">{{ $t('common.close') }}</v-btn>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      message: '',
      color: 'success'
    }
  },
  created: function () {
    this.$store.watch(
      (state) => state.snackbar.snack,
      () => {
        const msg = this.$store.state.snackbar.snack
        const color = this.$store.state.snackbar.color
        if (msg !== '') {
          this.show = true
          this.color = color
          this.message = this.$store.state.snackbar.snack
          this.$store.commit('SET_SNACKBAR', { snack: '', color: 'success' })
        }
      }
    )
  }
}
</script>
